import { render, staticRenderFns } from "./DraggableOptionsWrapper.vue?vue&type=template&id=674cb996"
import script from "./DraggableOptionsWrapper.vue?vue&type=script&lang=js"
export * from "./DraggableOptionsWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports